import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import StatusIndicator from '../../../components/ui/StatusIndicator';


export default function StatusManagementPanel({ currentStatus, onStatusUpdate }) {
  const [newStatus, setNewStatus] = useState('');
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleStatusUpdate = async () => {
    if (!newStatus || newStatus === currentStatus) {
      return;
    }

    try {
      setUpdating(true);
      setError('');
      setSuccessMessage('');
      
      // ✅ Call parent's update handler which has shipmentId
      await onStatusUpdate(newStatus);
      
      setSuccessMessage('✓ Statut mis à jour avec succès');
      setNewStatus(''); // Reset selection after success
      
      // Clear success message after 3 seconds
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('❌ Erreur mise à jour statut:', err);
      setError(err?.message || 'Erreur lors de la mise à jour du statut');
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="RefreshCw" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-lg font-semibold text-foreground">Gestion du statut</h2>
      </div>
      
      <div className="space-y-4">
        <div className="bg-muted/50 rounded-lg p-4">
          <p className="text-sm text-muted-foreground mb-2">Statut actuel:</p>
          <StatusIndicator status={currentStatus} label={currentStatus} size="lg" />
        </div>
        
        <Select
          label="Nouveau statut"
          options={[
            { value: 'en_attente', label: 'En attente' },
            { value: 'depose', label: 'Déposé' },
            { value: 'en_preparation', label: 'En préparation' },
            { value: 'en_transit', label: 'En transit' },
            { value: 'arrive_abidjan', label: 'Arrivé à Abidjan' },
            { value: 'en_livraison', label: 'En livraison' },
            { value: 'livre', label: 'Livré' },
            { value: 'annule', label: 'Annulé' }
          ]}
          value={newStatus}
          onChange={setNewStatus}
          description="Sélectionnez le nouveau statut de l'envoi"
        />
        
        <Button
          variant="default"
          fullWidth
          iconName="Check"
          iconPosition="left"
          loading={updating}
          onClick={handleStatusUpdate}
          disabled={!newStatus || newStatus === currentStatus || updating}
        >
          Mettre à jour
        </Button>
        
        {/* ✅ Success Message */}
        {successMessage && (
          <div className="mt-4 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
            {successMessage}
          </div>
        )}
        
        {/* ❌ Error Message */}
        {error && (
          <div className="mt-4 bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}